module.exports = __webpack_public_path__ + "static/01-aaa3266db2295e87339a9e2a5105ccc9.jpg";